import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-inprocess-review.component.ajs.html';

const MODULE_NAME = 'agentBookingMailInprocessAskReview';

class AgentBookingMailInprocessReviewCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailInprocessReview implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailInprocessReviewCtrl];
}

export default MODULE_NAME;
